import { render, staticRenderFns } from "./MajorationDownload.vue?vue&type=template&id=2f5c06c4"
import script from "./MajorationDownload.vue?vue&type=script&lang=js"
export * from "./MajorationDownload.vue?vue&type=script&lang=js"
import style0 from "./MajorationDownload.vue?vue&type=style&index=0&id=2f5c06c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports